import { Tooltip } from 'antd'
import { TooltipPlacement } from 'antd/es/tooltip'
import React from 'react'
import styles from '../SAPPCalendar.module.css'

interface ICustomTooltipProps {
  title: React.ReactNode
  children: React.ReactNode
  placement?: TooltipPlacement
}

const CustomTooltip = ({
  title,
  children,
  placement = 'top'
}: ICustomTooltipProps) => {
  return (
    <Tooltip
      color='#ffffff'
      title={<div className={styles['text-gray-600']}>{title}</div>}
      placement={placement}
    >
      <div>{children}</div>
    </Tooltip>
  )
}

export default CustomTooltip
